export default "__VITE_ASSET__DBaroaAP__"